/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

// ** Initial State
const initialState = {
  files: [],
  scanned: false,
  accountingData: {}
};

// ** Reducer
const accountingData = createSlice({
  name: 'accountingData',
  initialState,
  reducers: {
    setFiles: (state, action) => {
      state.files = action.payload;
    },
    setScanned: (state, action) => {
      state.scanned = action.payload;
    },
    setAccountingData: (state, action) => {
      state.accountingData = action.payload;
    },
    clearAccounting: (state, action) => {
      state.files = [];
      state.scanned = false;
      state.accountingData = [];
    }
  }
});

export const { setFiles, setScanned, setAccountingData, clearAccounting } =
  accountingData.actions;

export default accountingData.reducer;
